import * as types from "../actionTypes";
import { SET_PROJECT_TEAM_SUB_ITEMS_MANAGEMENT_MODAL_INFO } from "../actionTypes";

export const setAddModalInfo = info => {
  return {
    type: types.SET_PROJECT_SUB_ITEMS_ADD_MODAL_INFO,
    info: info
  };
};

export const closeAddModal = () => {
  return {
    type: types.CLOSE_PROJECT_SUB_ITEMS_ADD_MODAL
  };
};

export const setManagementTeamItemsModalInfo = info => {
  return {
    type: types.SET_PROJECT_TEAM_SUB_ITEMS_MANAGEMENT_MODAL_INFO,
    info
  };
};

export const closeManagementTeamItemsModal = () => {
  return {
    type: types.CLOSE_PROJECT_TEAM_SUB_ITEMS_MANAGEMENT_MODAL
  };
};
